import axios from 'axios'
import baseUrl from './baseUrl'
import store from '../store'
const errors = err => {
  console.error(err.response ? err.response.data.stack : err.stack)
  return Promise.reject(err.response ? err.response.data.message:'Houve uma falha na comunição, verifique sua internet e tente novamente')
}
const headers = {token: localStorage.getItem('token')}
const letreiros = axios.create({ baseURL: baseUrl.tnAdmin, headers })

export const listLetreiros = ({ page = 1, limit = 12, search } = {}) => letreiros
  .get('/letreiros', { params: { page, limit, search } })
  .then(({data}) => {
    const items = data && Array.isArray(data.items) ? data.items : data
    const total = data && typeof data.total === 'number' ? data.total : (Array.isArray(items) ? items.length : 0)
    store.commit('letreiros/setData', items)
    store.commit('letreiros/setTotal', total)
    return data
  })
  .catch(errors)

export const createLetreiro = (letreiroData) => letreiros.post('/letreiros', letreiroData).then(({data}) => data).catch(errors)

export const getLetreiroById = (id) => letreiros.get(`/letreiros/${id}`).then(({data}) => data).catch(errors)

export const updateLetreiro = (id, letreiroData) => letreiros.patch(`/letreiros/${id}`, letreiroData).then(({data}) => data).catch(errors)

export const deleteLetreiro = (id) => letreiros.delete(`/letreiros/${id}`).then(({data}) => data).catch(errors)

export const getDataToLetreiro = (url) => letreiros.get(`/letreiros/external-by-url/${encodeURIComponent(url)}`).then(data => store.commit("letreiros/setDataToLetreiro", data.data))
